/**
 * Advisor Primary Goals - Standardized goals for mySuccession platform usage
 * Used during profile completion and saved to team_members.primary_goals
 */
export const ADVISOR_PRIMARY_GOALS = [
  'Plan my succession exit',
  'Understand my business value',
  'Optimize my practice for sale',
  'Find a successor',
  'Transition my book of business',
  'Partnership succession planning',
  'Reduce business risks',
  'Increase business value',
  'Prepare for retirement',
  'Build a continuity plan',
  'Mentor next generation',
  'Exploring options'
] as const;

export type AdvisorPrimaryGoal = typeof ADVISOR_PRIMARY_GOALS[number];
